import {graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {RenameProjectStageMutation, RenameProjectStageMutation$data} from './__generated__/RenameProjectStageMutation.graphql';

type RenameProjectStageInput = {
	id: string;
	name: string;
};

const mutation = graphql`
	mutation RenameProjectStageMutation($input: RenameProjectStageInput!) {
		renameProjectStage(input: $input) {
			projectStage {
				id
				name
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: RenameProjectStageInput,
	onSuccess?: (response: RenameProjectStageMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	return trackAndCommitMutation<RenameProjectStageMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				id: input.id,
				name: input.name,
			},
		},
		configs: [],
		onCompleted: onSuccess,
		onError,
	});
}

export default {commit};
